<template>
    <div>       
        <br/>There are 3 types of potions and 1 type of gem:
        <ul>
            <li><a @click="scrollTo('curative')" >Curative</a></li>
            <li><a @click="scrollTo('mnemonic')">Mnemonic</a></li>
            <li><a @click="scrollTo('restorative')">Restorative</a></li>
            <li><a @click="scrollTo('ressurective')">Resurrective</a></li>                    
        </ul>
        <br/><br/>
        
        <div v-for="type in types" :key="type">
            <h2 :id="type" style="color:cornflowerblue">{{filterString(type)}}:</h2>            
            <table style="width:100%">
                <tr>
                    <th>Name</th>
                    <th>Level</th>
                    <th>Effect</th>
                </tr>
                <tr v-for="potion in sortedPotions(type)" :key="potion.id"> 
                    <td style="padding-left:4px">{{potion.name}}</td>                    
                    <td style="text-align:center">{{potion.minLvl}}</td>
                    <td style="padding-left:4px">{{potion.effect}}</td>
                </tr>
            </table>  
            <br/>
        </div>
    </div>
</template>
<script>
//
import {potions} from "../../../play/data"

export default {
  components: {
  },
  props:{
  },
  mounted(){
  },
  data(){
      return{
          types:['curative', 'mnemonic', 'restorative', 'ressurective'],          
      }
  },
  methods:{
      sortedPotions(type){
        let allPotions = [...potions]
        let sortedPotions = allPotions.filter(potion=>potion.type == type )        
        //let sorted = sortedPotions.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        return sortedPotions
      },
      scrollTo(id){
        let section = document.getElementById(id)
        section.scrollIntoView({behavior: "smooth"})
      },    
      filterString(str){
         // let remove = str.replace("Handed"," Handed")
          let newStr = str[0].toUpperCase() + str.substring(1)
          return newStr
      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>